module.exports = __webpack_public_path__ + "img/icon-linkedin.5d781289b3d05e960bda539845363607.svg";